import { render, staticRenderFns } from "./EmptyCalendar.vue?vue&type=template&id=3398c82a&"
import script from "./EmptyCalendar.vue?vue&type=script&lang=js&"
export * from "./EmptyCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports